import { useApiDefaults } from "hooks/useApiDefaults";
import axios from 'config/axios';
import { useQuery } from '@tanstack/react-query';
import { ReactQueryKeys } from 'config/constant';
import { useSelector, useDispatch } from 'react-redux';
import {
  fetchCateringProductList,
  fetchCateringProductListSuccess,
  fetchCateringProductListFailure,
} from 'redux/actions/cateringAndMeal';
import { refetchOnWindowFocus } from 'config/reactQuery';

export const useGetCateringProducts = () => {
  const apiDefaults = useApiDefaults();
  const dispatch = useDispatch();
  const {cateringDepartmentTree} = useSelector(({cateringAndMeal}) => cateringAndMeal) 

  const isVincent = apiDefaults?.RSAClientId === "298" // TODO check for other catering clients
  const category_ids = isVincent ? "" : cateringDepartmentTree?.[0]?.category_ids
  
  const fetchCateringProducts = async () => {
    const body = {
      category_ids,
      category_slug: "catering-mealkit",
      ift: "",
      limit: "200",
      sort_by: "",
      min_price: "",
      max_price: "",
      funtional_text: "",
      funtional_level: "",
      function_names: "",
      ...apiDefaults
    };
    
    dispatch(fetchCateringProductList());
    try {
      const response = await axios.post('/AogGetProducts', body);
      const data = response?.data?.data || {};
      dispatch(fetchCateringProductListSuccess(data));
      return data;
    } catch (error) {
      dispatch(fetchCateringProductListFailure({ error: error?.data?.message || error.message }));
      throw error;
    }
  };

  const { data, isLoading, error } = useQuery({
    queryKey: [ReactQueryKeys.CATERING_PRODUCTS, category_ids],
    queryFn: fetchCateringProducts,
    enabled: Boolean(category_ids) || isVincent,
    refetchOnWindowFocus,
  });

  return {
    data,
    isLoading,
    error,
  };
};